import { render, staticRenderFns } from "./moduleTodo.vue?vue&type=template&id=9d2f8032&"
import script from "./moduleTodo.vue?vue&type=script&lang=ts&"
export * from "./moduleTodo.vue?vue&type=script&lang=ts&"
import style0 from "./moduleTodo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports